angular.module('charts')
    .directive('dblStudentLoginCardReport', [function() {

    return {
        restrict: 'E',
        templateUrl: '/resources/charts/directives/student-login-card-report/dbl-student-login-card-report.directive.html',
        scope: {
            dblAuthIsText: '=',
            dblClassroom: '=',
            dblLoginCode: '=',
            dblStudentList: '=',
            dblStudentLoginUrl: '=',
            dblSchoolCode: '='
        },
        link: function(scope, element) {

        }
    };
}]);
